import {Tablet} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const TabletIcon = createLucideIcon(Tablet, 'TabletIcon');
